import type { CiaDependencies } from '~/composables/useCia/types';
import { BLOOMREACH_COOKIE, CHECKOUT_STEPS } from '~~/constants/bloomreach';
import { getFirstCookieValue } from '~~/helpers/cookies/getFirstCookieValue';
import { Logger } from '~~/helpers/logger';

type CheckoutParams = {
  step: number;
  cartId?: string;
  email?: string;
  userId?: string;
};

type CheckoutRequest = {
  locale: string;
  cart_id: string;
  step: number;
  cookie?: string;
  email?: string;
  user_id?: string;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, cookies, languageAndCountry } = dependencies;

  return async ({
    step,
    email,
    cartId,
    userId,
  }: CheckoutParams): Promise<unknown> => {

    if (import.meta.server) {

      if (import.meta.dev) {

        Logger.debug('cia|checkout SSR suppressed');
      
      }

      return Promise.resolve();
    
    }

    if (!cartId || !Object.values(CHECKOUT_STEPS).includes(step)) {

      return Promise.resolve();
    
    }

    const bloomreachCookieValue = getFirstCookieValue(cookies?.get(BLOOMREACH_COOKIE));

    const payload: CheckoutRequest = {
      locale: languageAndCountry,
      cart_id: cartId,
      step,
      cookie: bloomreachCookieValue,
    };

    if (email) {

      payload.email = email;
    
    }

    if (userId) {

      payload.user_id = userId;
    
    }

    return fetch('/cia/checkout', {
      method: 'POST',
      body: payload,
    });
  
  };

};
